import { GET_CUSTOM_FIELDS } from '../../../custom-fields/custom-fields.store';

export function createCostComparisonGraphTooltipLabel(
  tooltipItem,
  workspacesCosts: { [workspaceId: string]: string[] },
): string {
  const customFieldId =
    Object.values(workspacesCosts)[tooltipItem.dataIndex][tooltipItem.datasetIndex];
  const customFieldName = GET_CUSTOM_FIELDS()[customFieldId]?.label;
  let newTitle = customFieldName;

  newTitle = `${newTitle} (${tooltipItem.formattedValue})`;

  return newTitle;
}
